module.exports = __webpack_public_path__ + "static/media/shopping-bag.c8fb6f43.svg";